<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-button @click.native="onShowModal">New payment</app-button>
      <app-cells><h2 class="title">Sent</h2></app-cells>
      <v-client-table
        :data="table_sent.items"
        :columns="table_sent.columns"
        :options="table_sent.options"
        class="table-default"
        :class="{ 'table-default--loading': table_sent_preloader }"
      >
        <template #h__id><div class="table-default__left">ID</div></template>
        <template #id="{ row }">
          <router-link
            :to="{ name: 'finance-altura-reimbursement-detail', params: { id: row.id } }"
            class="table-default__link-border"
          >
            Invoice - {{ row.id }}
          </router-link>
        </template>
        <template #date="{ row }">{{ formatDate(row.date) }}</template>
        <template #amount="{ row }">{{ formatAmount(row.amount) }}</template>
        <template #currency="{ row }">{{ row.currency.code }}</template>
        <template #amount_tzs="{ row }">{{ formatAmount(row.amount_tzs) }}</template>
        <template #allocated_amount="{ row }">{{ formatAmount(row.allocated_amount) }}</template>
        <template #remaining_amount="{ row }">{{ formatAmount(row.remaining_amount) }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationSent"
            v-if="pagination_sent.pages > 1"
            v-model="pagination_sent.page"
            :page-count="pagination_sent.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_sent.count" :count="table_sent.items.length" :page="pagination_sent.page" />
      </app-cells>
      <app-cells><h2 class="title">Waiting EFD</h2></app-cells>
      <v-client-table
        :data="table_waiting.items"
        :columns="table_waiting.columns"
        :options="table_waiting.options"
        class="table-default"
        :class="{ 'table-default--loading': table_waiting_preloader }"
      >
        <template #h__id><div class="table-default__left">ID</div></template>
        <template #id="{ row }">
          <router-link
            :to="{ name: 'finance-altura-reimbursement-detail', params: { id: row.id } }"
            class="table-default__link-border"
          >
            Invoice - {{ row.id }}
          </router-link>
        </template>
        <template #date="{ row }">{{ formatDate(row.date) }}</template>
        <template #date_received="{ row }">{{ formatDate(row.date_received) }}</template>
        <template #amount="{ row }">{{ formatAmount(row.amount) }}</template>
        <template #currency="{ row }">{{ row.currency.code }}</template>
        <template #amount_tzs="{ row }">{{ formatAmount(row.amount_tzs) }}</template>
        <template #allocated_amount="{ row }">{{ formatAmount(row.allocated_amount) }}</template>
        <template #remaining_amount="{ row }">{{ formatAmount(row.remaining_amount) }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationWaiting"
            v-if="pagination_waiting.pages > 1"
            v-model="pagination_waiting.page"
            :page-count="pagination_waiting.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_waiting.count" :count="table_waiting.items.length" :page="pagination_waiting.page" />
      </app-cells>
      <app-cells><h2 class="title">Completed</h2></app-cells>
      <v-client-table
        :data="table_completed.items"
        :columns="table_completed.columns"
        :options="table_completed.options"
        class="table-default"
        :class="{ 'table-default--loading': table_completed_preloader }"
      >
        <template #h__id><div class="table-default__left">ID</div></template>
        <template #id="{ row }">
          <router-link
            :to="{ name: 'finance-altura-reimbursement-detail', params: { id: row.id } }"
            class="table-default__link-border"
          >
            Invoice - {{ row.id }}
          </router-link>
        </template>
        <template #date="{ row }">{{ formatDate(row.date) }}</template>
        <template #date_received="{ row }">{{ formatDate(row.date_received) }}</template>
        <template #amount="{ row }">{{ formatAmount(row.amount) }}</template>
        <template #currency="{ row }">{{ row.currency.code }}</template>
        <template #amount_tzs="{ row }">{{ formatAmount(row.amount_tzs) }}</template>
        <template #allocated_amount="{ row }">{{ formatAmount(row.allocated_amount) }}</template>
        <template #remaining_amount="{ row }">{{ formatAmount(row.remaining_amount) }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationCompleted"
            v-if="pagination_completed.pages > 1"
            v-model="pagination_completed.page"
            :page-count="pagination_completed.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_completed.count" :count="table_completed.items.length" :page="pagination_completed.page" />
      </app-cells>
    </template>
    <modal
      name="create_payment"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button class="popup__close" type="button" @click="$modal.hide('create_payment')"></button>
        <div class="popup__title">Create payment</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Date" required>
              <app-date-picker
                v-model="form.date"
                placeholder="Date"
                :error="$v.form.date.$error"
              />
              <template #error>
                <div v-if="$v.form.date.$dirty && !$v.form.date.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Amount" label-for="amount" required>
              <app-fin-number
                v-model="form.amount"
                id="amount"
                name="amount"
                :error="$v.form.amount.$error"
              />
              <template #error>
                <div v-if="$v.form.amount.$dirty && !$v.form.amount.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Currency" required>
              <app-select
                v-model="form.currency"
                :options="currency_options"
                :reduce="item => item.code"
                :clearable="false"
                placeholder="Currency"
                :error="$v.form.currency.$error"
              />
              <template #error>
                <div v-if="$v.form.currency.$dirty && !$v.form.currency.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells :indent="false" position="center">
              <app-button ref="submit" :disabled="$v.form.$error" type="submit">Create</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getClimbingReimbursementList, getCurrencyList, postClimbingReimbursement } from '@/http'
import { required } from 'vuelidate/lib/validators'
import { format, parseISO } from 'date-fns'

export default {
  name: 'AlturaReimbursementPayments',
  data() {
    return {
      page_loaded: false,
      form: {},
      currency_options: [],
      table_sent: {
        items: [],
        columns: [
          'id',
          'date',
          'amount',
          'currency',
          'amount_tzs',
          'allocated_amount',
          'remaining_amount',
        ],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'amount': 'Amount',
            'currency': 'Currency',
            'amount_tzs': 'Amount TZS',
            'allocated_amount': 'Allocated',
            'remaining_amount': 'Unallocated',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_sent: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_sent_preloader: false,
      table_waiting: {
        items: [],
        columns: [
          'id',
          'date',
          'date_received',
          'amount',
          'currency',
          'amount_tzs',
          'allocated_amount',
          'remaining_amount',
        ],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'date_received': 'Date received',
            'amount': 'Amount',
            'currency': 'Currency',
            'amount_tzs': 'Amount TZS',
            'allocated_amount': 'Allocated',
            'remaining_amount': 'Unallocated',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_waiting: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_waiting_preloader: false,
      table_completed: {
        items: [],
        columns: [
          'id',
          'date',
          'date_received',
          'amount',
          'currency',
          'amount_tzs',
          'allocated_amount',
          'remaining_amount',
        ],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'date_received': 'Date received',
            'amount': 'Amount',
            'currency': 'Currency',
            'amount_tzs': 'Amount TZS',
            'allocated_amount': 'Allocated',
            'remaining_amount': 'Unallocated',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_completed: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_completed_preloader: false,
    }
  },
  validations: {
    form: {
      currency: { required },
      date: { required },
      amount: { required },
    }
  },
  created() {
    Promise.all([getCurrencyList(), this.fetchItemsSent(), this.fetchItemsWaiting(), this.fetchItemsCompleted()])
      .then(response => {
        this.currency_options = response[0].data
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsSent() {
      this.table_sent_preloader = true
      const response = await getClimbingReimbursementList({
        page: this.pagination_sent.page,
        page_size: 20,
        category: 'sent'
      })
      this.table_sent.items = response.data.results
      this.pagination_sent.pages = response.data.pages
      this.pagination_sent.count = response.data.count
      this.table_sent_preloader = false
    },
    onClickPaginationSent(page) {
      this.pagination_sent.page = page
      this.fetchItemsSent()
    },
    async fetchItemsWaiting() {
      this.table_waiting_preloader = true
      const response = await getClimbingReimbursementList({
        page: this.pagination_waiting.page,
        page_size: 20,
        category: 'waiting'
      })
      this.table_waiting.items = response.data.results
      this.pagination_waiting.pages = response.data.pages
      this.pagination_waiting.count = response.data.count
      this.table_waiting_preloader = false
    },
    onClickPaginationWaiting(page) {
      this.pagination_waiting.page = page
      this.fetchItemsWaiting()
    },
    async fetchItemsCompleted() {
      this.table_completed_preloader = true
      const response = await getClimbingReimbursementList({
        page: this.pagination_completed.page,
        page_size: 20,
        category: 'completed'
      })
      this.table_completed.items = response.data.results
      this.pagination_completed.pages = response.data.pages
      this.pagination_completed.count = response.data.count
      this.table_completed_preloader = false
    },
    onClickPaginationCompleted(page) {
      this.pagination_completed.page = page
      this.fetchItemsCompleted()
    },
    fetchTables() {
      this.fetchItemsSent()
      this.fetchItemsWaiting()
      this.fetchItemsCompleted()
    },
    onShowModal() {
      this.form = {}
      this.$v.form.$reset()
      this.$modal.show('create_payment')
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly'
        })
      } else {
        this.sendForm()
      }
    },
    async sendForm() {
      this.$refs.submit.preload = true
      postClimbingReimbursement(this.form)
        .then(() => {
          this.fetchTables()
          this.$notify({
            type: 'success',
            title: 'Payment created'
          })
          this.$modal.hide('create_payment')
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    formatDate(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
    formatAmount(string) {
      return string ? new Intl.NumberFormat('ru-RU').format(string) : '-'
    },
  }
}
</script>
